var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#FFDBDB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.333 19.1667V24.1667M21.6663 19.1667V24.1667M13.333 15.8333H26.6663M25.833 15.8333L25.1105 25.9517C25.0806 26.3722 24.8924 26.7657 24.5839 27.053C24.2755 27.3403 23.8696 27.5 23.448 27.5H16.5513C16.1298 27.5 15.7239 27.3403 15.4154 27.053C15.1069 26.7657 14.9188 26.3722 14.8888 25.9517L14.1663 15.8333H25.833ZM22.4997 15.8333V13.3333C22.4997 13.1123 22.4119 12.9004 22.2556 12.7441C22.0993 12.5878 21.8874 12.5 21.6663 12.5H18.333C18.112 12.5 17.9 12.5878 17.7438 12.7441C17.5875 12.9004 17.4997 13.1123 17.4997 13.3333V15.8333H22.4997Z",
    stroke: "#F32D2D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/images/delete_icon.30798fd8e2a70fb29cc0ec83ea53ff5d.svg";
export { ForwardRef as ReactComponent };